import { type PrimitiveAtom, useAtom } from 'jotai'
import React from 'react'

import { type Question, useSurveyQueryQuestions } from '~/hooks/useSurveyQuery'

import {
  QuestionTreeViewBoxInner,
  type QuestionTreeViewBoxInnerProps,
} from './QuestionTreeViewBoxInner'

export type QuestionTreeViewBoxProps = Pick<
  QuestionTreeViewBoxInnerProps<Question>,
  'isMatrixQuestionSelectable' | 'onSelectedQuestionIdChange'
> & {
  'data-testid'?: string
  questionIdsAtom: PrimitiveAtom<Question['question_id'][]>
}

export const QuestionTreeViewBox = ({
  'data-testid': dataTestId = 'components-features-question-tree-view-box',
  onSelectedQuestionIdChange,
  questionIdsAtom,
  ...rest
}: QuestionTreeViewBoxProps) => {
  const questions = useSurveyQueryQuestions()

  const [questionIds, setQuestionIds] = useAtom(questionIdsAtom)

  const handleSelectedQuestionIdChange = React.useCallback<
    EH<QuestionTreeViewBoxInnerProps<Question>, 'onSelectedQuestionIdChange'>
  >(
    (questionIds) => {
      setQuestionIds(questionIds)

      onSelectedQuestionIdChange?.(questionIds)
    },
    [onSelectedQuestionIdChange, setQuestionIds],
  )

  return (
    <QuestionTreeViewBoxInner
      {...rest}
      data-testid={dataTestId}
      questions={questions}
      selectedQuestionIds={questionIds}
      onSelectedQuestionIdChange={handleSelectedQuestionIdChange}
    />
  )
}
